import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { zIndex } from '@/theme';

/**
 * Keyboard-first escape hatch to the page content, ported from
 * Web/src/components/global/SkipLinks/.
 *
 * Off-screen until something inside it takes focus, then it slides in. This app
 * had no skip link at all, so reaching the plan tree with a keyboard meant
 * tabbing through the whole header first.
 */

/** The id `AppShell` puts on its `<main>`, and the skip link's target. */
export const MAIN_CONTENT_ID = 'main-content';

export const SkipLinks = () => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      gap={1}
      sx={{
        position: 'fixed',
        top: 'var(--spacing-unit-1)',
        left: '50%',
        zIndex: zIndex.floatingBar,
        width: 'fit-content',
        p: 'var(--spacing-unit-1)',
        bgcolor: 'var(--bg-panel)',
        borderRadius: 'var(--border-radius-medium)',
        boxShadow: 'var(--shadow-small)',
        transform: 'translate(-50%, -200px)',
        transition: 'transform var(--duration-base) ease',
        '&:focus-within': { transform: 'translate(-50%, 0)' },
      }}
    >
      <Button
        variant="contained"
        size="small"
        href={`#${MAIN_CONTENT_ID}`}
        data-automation-id="skip-to-content"
      >
        {t('skipLinks.SkipToContent')}
      </Button>
    </Stack>
  );
};
